import { render, staticRenderFns } from "./groupB.vue?vue&type=template&id=f3388cee&scoped=true"
import script from "./groupB.vue?vue&type=script&lang=js"
export * from "./groupB.vue?vue&type=script&lang=js"
import style0 from "./groupB.vue?vue&type=style&index=0&id=f3388cee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3388cee",
  null
  
)

export default component.exports